import BaseTrackingController from "../../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../model/InteractionEventName";
import CollaborationDialogPlayer from "../../ngt/dialog/CollaborationDialogPlayer";
import GameModel from "../../core/model/GameModel";
import SingleChoiceData from "../../core/model/SingleChoiceData";
import MultipleChoiceData from "../../core/model/MultipleChoiceData";

export default class TrackingController extends BaseTrackingController {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, gameModel) {
        super(dispatcher);
        this._gameModel = gameModel;
        this._handleOptionChosenBound = this._handleOptionChosen.bind(this);
        this._handleMultipleOptionsChosenBound = this._handleMultipleOptionsChosen.bind(this);
        this._dispatcher.addEventListener(CollaborationDialogPlayer.OPTION_CHOSEN, this._handleOptionChosenBound);
        this._dispatcher.addEventListener(CollaborationDialogPlayer.MULTIPLE_OPTIONS_CHOSEN, this._handleMultipleOptionsChosenBound);
    }

    destroy() {
        this._dispatcher.removeEventListener(CollaborationDialogPlayer.OPTION_CHOSEN, this._handleOptionChosenBound);
        this._dispatcher.removeEventListener(CollaborationDialogPlayer.MULTIPLE_OPTIONS_CHOSEN, this._handleMultipleOptionsChosenBound);
    }

    /**
     * 
     * @param {{params: {optionData: SingleChoiceData}}} param0 
     */
    _handleOptionChosen({ params: optionData }) {
        this.trackDialogOption(optionData);
    }

    /**
     * 
     * @param {{params: {optionData: MultipleChoiceData}}} param0 
     */
    _handleMultipleOptionsChosen({ params: optionsData }) {
        this.trackDialogOptions(optionsData);
    }

    /**
     * @param {ProgressValue} value 
     */
    trackProgress(value) {
        this._dispatchProgressEvent(value, this._gameModel.elapsedTime);
    }

    /**
     * @param {SingleChoiceData} optionData 
     */
    trackDialogOption(optionData) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_SINGLE_OPTION_CHOSEN,
            {
                episode_id: optionData.episodeId,
                dialog_id: optionData.dialogId,
                situation_id: optionData.situationId,
                option_id: optionData.optionId,
                time_to_answer: optionData.timeToAnswer
            },
            this._gameModel.elapsedTime
        );
    }

    /**
     * 
     * @param {MultipleChoiceData} optionsData 
     */
    trackDialogOptions(optionsData) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_MULTIPLE_OPTIONS_CHOSEN,
            {
                episode_id: optionsData.episodeId,
                dialog_id: optionsData.dialogId,
                situation_id: optionsData.situationId,
                option_ids: optionsData.optionIds,
                time_to_answer: optionsData.timeToAnswer
            },
            this._gameModel.elapsedTime
        );
    }

    /**
     * @param {String} dialogId 
     */
    trackDialogStart(dialogId) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_STARTED,
            { dialog_id: dialogId },
            this._gameModel.elapsedTime
        );
    }

    /**
     * @param {String} dialogId 
     */
    trackDialogEnd(dialogId) {
        this._dispatchInteractionEvent(
            InteractionEventName.DIALOG_ENDED,
            { dialog_id: dialogId },
            this._gameModel.elapsedTime
        );
    }


    _puzzleIdFromIndex(puzzleIdx) {
        //convert index to 'id' 
        return puzzleIdx + 1;
    }

}
